import React, { Component } from 'react'
import cn from 'classnames'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import Table from '@material-ui/core/Table'
import TableCell from '@material-ui/core/TableCell'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { Collapse } from '@material-ui/core'

class MaterialTableBody extends Component {
  onActionClick = (row, action) =>
    typeof action.onClick === 'function' ? () => action.onClick(row) : null

  onRowClick = (row, func) => {
    const onClick = e => {
      const actionCell = e.target.closest('.action-cell')

      if (!actionCell) {
        func(row, e)
      }
    }

    return typeof func === 'function' ? onClick : null
  }

  render() {
    const {
      data,
      columns,
      actions,
      dense,
      onRowSelect,
      onRowClick,
      showAdditionalRows,
      combinedColumns,
      selectedRowId,
    } = this.props
    const cellSize = dense && dense.state ? 'small' : 'medium'

    if (!Array.isArray(data) || data.length < 1) {
      return null
    }

    const renderActionCell = row => (
      <TableCell
        size={cellSize}
        key={`key_${row.id}`}
        data-label="Actions"
        className="action-cell">
        <div className="action-box">
          {[...actions].map((action, aKey) => {
            const { tooltip, className, icon, callback, component } = action
            const ActionButton = component || IconButton
            const props =
              callback && typeof callback === 'function'
                ? callback(row)
                : callback

            return (
              <ActionButton
                {...props}
                title={tooltip}
                href={null}
                key={aKey}
                size="small"
                className={className}
                onClick={this.onActionClick(row, action)}>
                <Icon>{icon}</Icon>
              </ActionButton>
            )
          })}
        </div>
      </TableCell>
    )

    const renderTableCell = (column, row, key, keyRow) => {
      if (column.field === '__actions__') {
        return renderActionCell(row)
      }

      if (!column.enabled) {
        return null
      }

      const cellValue = column.render(row, keyRow)

      return (
        <TableCell
          key={`cell_${key}`}
          size={cellSize}
          data-label={column.title}
          style={column.styles}
          className={column.cellClassName}>
          {cellValue}
        </TableCell>
      )
    }

    const renderTableRow = (row, key) => {
      const { enabled = true, slaves, id, subrow } = row
      const selected = Boolean(onRowSelect) && onRowSelect(row)
      const masterEvent = slaves && Array.isArray(slaves) && slaves.length
      const isRowActive =
        selected || (selectedRowId && id && selectedRowId === id)
      const rowClick =
        row.hasOwnProperty('enableClick') && !row.enableClick
          ? null
          : this.onRowClick(row, onRowClick)

      return (
        <TableRow
          key={key}
          onClick={rowClick}
          className={cn({
            'table-row-active': isRowActive,
            'table-row-master': masterEvent,
            'table-row-even': !(key % 2),
            'table-row-disabled': !enabled,
            'table-row-subrow': subrow,
          })}>
          {[...columns].map((coll, keyCell) =>
            renderTableCell(coll, row, keyCell, key),
          )}
        </TableRow>
      )
    }

    const renderTableSlaveRow = (row, key) => (
      <TableRow key={`${key}_${key}`} className="logbook-slaves-event-wrapper">
        <TableCell
          size={cellSize}
          colSpan={combinedColumns}
          className="logbook-slaves-event-switcher">
          <Collapse
            in={
              row.id === showAdditionalRows || showAdditionalRows === 'show all'
            }
            className="logbook-slave-events">
            <Table>
              <TableBody>
                {row.slaves.map((subRow, subRowKey) => {
                  const slaveRow = {
                    ...subRow,
                    enableClick: false,
                  }

                  return renderTableRow(slaveRow, subRowKey)
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    )

    return (
      <TableBody className="table-body">
        {data.map((row, key) => {
          const { slaves } = row

          if (Array.isArray(slaves) && slaves.length) {
            return [renderTableRow(row, key), renderTableSlaveRow(row, key)]
          }

          return renderTableRow(row, key)
        })}
      </TableBody>
    )
  }
}

export default MaterialTableBody
